export default __webpack_public_path__ + "static/media/LISTA DE APROVADOS PARA OS CURSOS DE MESTRADO.03ff096c.pdf";